import { Box, Typography } from '@mui/material';

import MaintenanceLogo from '../../assets/icons/MaintenanceLogo';
import colors from '../../constants/colors';

const Maintenance = () => {
  return (
    <Box
      data-testid="maintenance"
      sx={{
        display: 'flex',
        flexDirection: {
          mobile: 'column',
          tablet: 'column',
          desktop: 'row',
        },
        justifyContent: 'space-around',
        flex: 1,
      }}
    >
      <Box
        sx={{
          justifyContent: 'center',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <MaintenanceLogo
          sx={{
            width: { mobile: 280, tablet: 654, desktop: 654 },
            height: { mobile: 175, tablet: 405, desktop: 405 },
          }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: colors.csaaGray,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: {
            mobile: 'none',
            tablet: 'none',
            desktop: 'center',
          },
          pt: {
            mobile: 2,
            tablet: 5,
            desktop: 0,
          },
          px: {
            mobile: 4,
            tablet: 4,
            desktop: 6,
          },
          textAlign: 'left',
        }}
      >
        <Typography
          sx={{
            fontSize: {
              mobile: '33px',
              tablet: '44px',
              desktop: '44px',
            },
            lineHeight: {
              mobile: '48px',
              tablet: '56px',
              desktop: '56px',
            },
            fontWeight: 700,
            letterSpacing: {
              mobile: 0.5,
              tablet: 0.6,
              desktop: 0.6,
            },
            color: colors.csaaBlack,
          }}
        >
          Sorry, we&apos;re down for maintenance.
        </Typography>
        <Typography
          sx={{
            fontSize: {
              mobile: '18px',
              tablet: '23px',
              desktop: '23px',
            },
            lineHeight: {
              mobile: '24px',
              tablet: '32px',
              desktop: '32px',
            },
            letterSpacing: 0.6,
            color: colors.csaaMid,
            mt: 2,
          }}
        >
          We should be up and running shortly. Thanks for your patience.
        </Typography>
      </Box>
    </Box>
  );
};

export default Maintenance;
